import './polyfill-for-ie';
// import '@able/web/dist/able-web.css';
// import '@able/react/dist/able-react.min.css';
import { IApplicationDefinition } from '@apps-config/app-definition';
import { History } from 'history';
import { enableLogging } from '@utils/logger';
import { loadFeatureFlags as loadIncidentManagementFlags } from '@telstra-connect/tickets/feature-flags/load-flags';
import { getTPAMSReportsFlags } from '@telstra-connect/tpams-reports/feature-flags/load-flags';
import { Application as IncidentsApplication } from '@applications/incidents';
import { ITicketsState } from '@telstra-connect/tickets/state';
import { Application as TPAMSApplication } from '@applications/tpams-reports';
import type { ITPAMSReportsAppState } from '@telstra-connect/tpams-reports/state';
import { ticketsReducer } from '@telstra-connect/tickets/reducers';
import { TPAMSReportsReducer } from '@telstra-connect/tpams-reports/reducers'
import 'telstra-ui/resources/telstraui.css'
import 'telstra-ui/resources/themes/pacific.css';

loadIncidentManagementFlags();
enableLogging();

function getIncidentsApplication() {
    return IncidentsApplication;
}

function getIncidentsReducer() {
    return ticketsReducer as unknown as ITicketsState;
}

function getTPAMSApplication() {
    return getTPAMSReportsFlags().application ? TPAMSApplication : null;
}

function getTPAMSReducer() {
    return getTPAMSReportsFlags().application
        ? TPAMSReportsReducer as unknown as ITPAMSReportsAppState : null;
}

type TGetSessionDetails = () => { sessionId: string; };

interface IApplications {
    Platform: {
        redesignDataRichTiles: boolean;
        redesignTilesPhase2: boolean;
        isTestCustomer: string[];
    };
}

export enum TransactionType {
    TRACKING_SERVICE = 'TRACKING_SERVICE',
    CANCELLING_AN_INCIDENT = 'CANCELLING_AN_INCIDENT'
}

declare const global: {
    TCONN: {
        getAppRoutingHistory: () => History,
        getSessionDetails: TGetSessionDetails,
        Platform: {
            isSecureAuth: boolean;
            showTNPSModal: (transactionType: TransactionType) => void;
            resolveTargetURL: (targetURL: string) => string;
        },
        IncidentManagement: {
            GetApplication: () => IApplicationDefinition,
            GetReducers: () => ITicketsState,
        },
        TPAMSReports: {
            GetApplication: () => IApplicationDefinition,
            GetReducers: () => ITPAMSReportsAppState
        },
        isGuestUser?: boolean;
    }
    applications: IApplications;
}
global.TCONN = { ...global.TCONN };
global.TCONN.IncidentManagement = {
    GetApplication: getIncidentsApplication,
    GetReducers: getIncidentsReducer
};
global.TCONN.TPAMSReports = {
    GetApplication: getTPAMSApplication,
    GetReducers: getTPAMSReducer
}

export default global;
